import React, { useEffect, useRef, useState } from "react";
import type { ColumnType, ColumnsType } from "antd/es/table";
import {
  Button,
  Col,
  Flex,
  Input,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import type { InputRef } from "antd";
import PaidIcon from "@mui/icons-material/Paid";
import SellIcon from "@mui/icons-material/Sell";
import type { FilterConfirmProps, FilterValue } from "antd/es/table/interface";
import CancelIcon from "@mui/icons-material/Cancel";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Dropdown, message } from "antd";
import { ArrowsAltOutlined, SearchOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import Highlighter from "react-highlight-words";
import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Skeleton } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import styled from "styled-components";
import axios from "axios";
import HomeIcon from "@mui/icons-material/Home";
import { DownOutlined, SmileOutlined } from "@ant-design/icons";

import { List, Switch } from "antd-mobile";
import {
  UnorderedListOutline,
  PayCircleOutline,
  SetOutline,
  ArrowsAltOutline,
} from "antd-mobile-icons";

import Globais, {
  formatarData,
  logout,
  validateToken,
  venderCota,
} from "../../components/Globais";
import {
  verificarSeTemPeriodoUsuario,
  verificarSeTemPeriodoUsuarioDefinido,
} from "../../uteis/periodoUsuario/Globais";
import { buscarTodosOsRepresentantesCotaUsuario } from "../../uteis/representante/Globais";
import {
  verificarCTUChecada,
  atualizarCotaUsuarioGlobais,
  regularizarSituacaoCTU,
  verificarPagamentoPorStatus,
  verificarSeMaisInformacoesAnuncioEstaoAusentes,
} from "../../uteis/cotaUsuario/Globais";
import { useQueryParams, StringParam } from "use-query-params";
import { criarAssinaturaCTU } from "../../uteis/assinatura/Globais";
import { useMediaQuery } from "react-responsive";

import { Button as BtnMobile, Dropdown as DropdownMobile } from "antd-mobile";

import { DropdownRef } from "antd-mobile/es/components/dropdown";
import ModalAcoes from "./components/ModalAcoes";
import { BotoesAcoes, Container, ContainerItems, Icon, Items } from "./styles";
import { Navigate, useNavigate } from "react-router-dom";

interface DataType {
  icone: any;
  id: number;
  cotaUsuarioId: number;
  key: string;
  empreend: string;
  nomeCidade: string;
  estado: string;
  numeroCota: number;
  checked: string;
  capacidade: string;
  aptoNome: string;
  bloco: string;
  apto: string;
  created_at: string;
  status: string;
  situacao: string;
}

type DataIndex = keyof DataType;
type MenuItem = Required<MenuProps>["items"][number];

export default function ViewCadastroCotas() {
  const [visualizacaoCotas, setVisualizarCotas] = useState<any>();
  const searchInput = useRef<InputRef>(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const periodoUsuario = useRef(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const emLote = useRef(0);
  const [isLoading, setIsLoading] = useState(true);
  const { Title } = Typography;
  const [statusParam, setStatusParam] = useQueryParams({ status: StringParam });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isDesktop = useMediaQuery({ query: "(min-width: 769px)" });

  const cotaUsuarioId = useRef(0);
  const usuarioLogadoId = useRef(0);

  const numeroCota = useRef(0);
  const empreend = useRef("");
  const status = useRef("");

  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchStatus = async () => {
      const Token = validateToken();

      const regularizarCTUs = (response: any, responseRepresentantes: any) => {
        response.data.map(async (p: any) => {
          switch (p.status) {
            case "AGUARDANDO_PERIODOS":
              regularizarSituacaoCTU(p.id, "AGUARDANDO_PERIODOS");
              break;
            case "AGUARDANDO_DEFINICAO_PERIODOS":
              regularizarSituacaoCTU(p.id, "AGUARDANDO_DEFINICAO_PERIODOS");
              break;
            default:
              regularizarSituacaoCTU(p.id, p.status);
          }
        });

        responseRepresentantes.data.map(async (q: any) => {
          switch (q.CotasUsuariosTable.status) {
            case "AGUARDANDO_PERIODOS":
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                "AGUARDANDO_PERIODOS"
              );

              break;
            case "AGUARDANDO_DEFINICAO_PERIODOS":
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                "AGUARDANDO_DEFINICAO_PERIODOS"
              );

              break;
            default:
              regularizarSituacaoCTU(
                q.CotasUsuariosTable.id,
                q.CotasUsuariosTable.status
              );
          }
        });

        setIsLoading(false);
      };

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/0`;
        const URLRepresentantes = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          const responseRepresentantes = await axios.get(URLRepresentantes, {
            headers: { Authorization: Token.AuthStr },
          });

          if (statusParam.status === "AGUARDANDO_MAISINFO_ANUNCIO") {
            let CTUId = "";
            let dataUpdated = "";
            let resultado1;
            let resultado2;

            // procurar CTU no status AGUARDANDO_MAISINFO_ANUNCIO mais recente
            if (response && responseRepresentantes) {
              if (response.data.length > 0) {
                resultado1 = response.data.map((p: any) => {
                  if (p.status === "AGUARDANDO_MAISINFO_ANUNCIO") {
                    if (dataUpdated === "" || p.updated_at > dataUpdated) {
                      dataUpdated = p.updated_at;
                      CTUId = p.id;
                    }
                  }
                });
              }
              if (responseRepresentantes.data.length > 0) {
                resultado2 = responseRepresentantes.data.map((p: any) => {
                  if (
                    p.CotasUsuariosTable.status ===
                    "AGUARDANDO_MAISINFO_ANUNCIO"
                  ) {
                    if (
                      dataUpdated === "" ||
                      p.CotasUsuariosTable.updated_at > dataUpdated
                    ) {
                      dataUpdated = p.CotasUsuariosTable.updated_at;
                      CTUId = p.CotasUsuariosTable.id;
                    }
                  }
                });
              }
              if ((await resultado1) || (await resultado2)) {
                if (CTUId !== "") {
                  document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${CTUId}`;
                } else {
                  regularizarCTUs(response, responseRepresentantes);
                }
              }
            } else {
              console.log("Erro ao buscar propriedades do usuário");
            }
            setIsLoading(false);
          } else {
            if (response && responseRepresentantes) {
              regularizarCTUs(response, responseRepresentantes);
            } else {
              console.log("Erro ao buscar propriedades do usuário");
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        document.location.href = "/login";
      }
    };
    fetchStatus();
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      let obj = localStorage.getItem("filtrosCadastroCotas");
      let page = localStorage.getItem("pageCadastroCotas");
      if (obj) {
        let novoFiltro = JSON.parse(obj);

        setFilteredInfo({
          empreend: novoFiltro.empreend,
          nomeCidade: novoFiltro.nomeCidade,
          capacidade: novoFiltro.capacidade,
          numeroCota: novoFiltro.numeroCota,
          icone: novoFiltro.icone,
        });
        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/0`;
        const URLRepresentantes = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          const responseRepresentantes = await axios.get(URLRepresentantes, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response && responseRepresentantes) {
            // console.log("response.data");

            // console.log(responseRepresentantes.data);

            let ArrayNovo = response.data.filter(async (p: any) => {
              p.key = p.id;
              p.empreend = p.CotaTable.AptoTable.EmpreendimentoTable.nome;
              p.cidade =
                p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome;
              p.estado =
                p.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao;
              p.numeroCota = p.CotaTable.numeroCota;
              p.cotaUsuarioId = p.id;
              usuarioLogadoId.current = p.usuarioId;
              p.prioridade = p.prioridade;
              p.cotaId = p.cotaId;
              p.aptoId = p.CotaTable.AptoTable.id;
              p.capacidade = p.CotaTable.AptoTable.capacidade;
              p.aptoNome = p.CotaTable.AptoTable.nome;
              p.situacao = "Proprietário";

              if (p.bloco && p.numeroApto) {
                p.infoApt = `${p.bloco} - ${p.numeroApto}`;
              } else {
                p.infoApt = "";
              }

              p.nomeCidade = `${p.cidade} - ${p.estado}`;

              if (
                p.status === "AGUARDANDO_AUTENTICACAO" ||
                p.status === "AGUARDANDO_APTOMAISINFO" ||
                p.status === "AGUARDANDO_REPRESENTANTE" ||
                p.status === "AGUARDANDO_PROCURACAO" ||
                p.status === "AGUARDANDO_CADASTRO" ||
                p.status === "AGUARDANDO_APTO" ||
                p.status === "AGUARDANDO_TITULARIDADE" ||
                p.status === "AGUARDANDO_COMPROVANTE" ||
                p.status === "AGUARDANDO_COTA" ||
                p.status === "AGUARDANDO_PERIODOS" ||
                p.status === "AGUARDANDO_DEFINICAO_ANUNCIO" ||
                p.status === "AGUARDANDO_MAISINFO_ANUNCIO" ||
                p.status === "AGUARDANDO_DEFINICAO_PERIODOS"
              ) {
                p.icone = "Cadastro pendente";
              } else {
                if (
                  p.status === "AUTENTICADA_NIVEL1" ||
                  p.status === "AUTENTICADA_NIVEL2"
                ) {
                  p.icone = "Autenticada";
                } else {
                  if (p.status === "VENDENDO") {
                    p.icone = "A Venda";
                  } else {
                    if (p.status === "CANCELADA") {
                      p.icone = "Cancelada";
                    } else if (
                      p.status === "VENDIDA_MC" ||
                      p.status === "VENDIDA_PROPRIO"
                    ) {
                      p.icone = "Vendida";
                    } else {
                      if (p.status === "DISTRATO") {
                        p.icone = "Distrato";
                      } else {
                        if (p.status === "AGUARDANDO_PAGAMENTO") {
                          p.icone = "Pendente pagamento";
                        }
                      }
                    }
                  }
                }
              }

              return p;
            });

            if (responseRepresentantes.data) {
              responseRepresentantes.data.filter((r: any) => {
                r.key = r.id;
                r.empreend =
                  r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.nome;
                r.cidade =
                  r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome;
                r.estado =
                  r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao;
                r.numeroCota = r.CotasUsuariosTable.CotaTable.numeroCota;
                r.cotaUsuarioId = r.CotasUsuariosTable.id;
                usuarioLogadoId.current = r.CotasUsuariosTable.usuarioId;
                r.cotaId = r.CotasUsuariosTable.CotaTable.id;
                r.aptoId = r.CotasUsuariosTable.CotaTable.AptoTable.id;
                r.capacidade =
                  r.CotasUsuariosTable.CotaTable.AptoTable.capacidade;
                r.aptoNome = r.CotasUsuariosTable.CotaTable.AptoTable.nome;
                r.situacao = "Representante";

                if (
                  r.CotasUsuariosTable.bloco &&
                  r.CotasUsuariosTable.numeroApto
                ) {
                  r.infoApt = `${r.CotasUsuariosTable.bloco} - ${r.CotasUsuariosTable.numeroApto}`;
                } else {
                  r.infoApt = "";
                }

                r.nomeCidade = `${r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.nome} - ${r.CotasUsuariosTable.CotaTable.AptoTable.EmpreendimentoTable.CidadeTable.EstadoTab.abreviacao}`;

                if (
                  r.CotasUsuariosTable.status === "AGUARDANDO_AUTENTICACAO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_APTOMAISINFO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_REPRESENTANTE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_PROCURACAO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_CADASTRO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_APTO" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_TITULARIDADE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_COMPROVANTE" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_COTA" ||
                  r.CotasUsuariosTable.status === "AGUARDANDO_PERIODOS" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_DEFINICAO_ANUNCIO" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_MAISINFO_ANUNCIO" ||
                  r.CotasUsuariosTable.status ===
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                ) {
                  r.icone = "Cadastro pendente";
                } else {
                  if (
                    r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL1" ||
                    r.CotasUsuariosTable.status === "AUTENTICADA_NIVEL2"
                  ) {
                    r.icone = "Autenticada";
                  } else {
                    if (r.CotasUsuariosTable.status === "VENDENDO") {
                      r.icone = "A Venda";
                    } else {
                      if (r.CotasUsuariosTable.status === "CANCELADA") {
                        r.icone = "Cancelada";
                      } else if (
                        r.CotasUsuariosTable.status === "VENDIDA_MC" ||
                        r.CotasUsuariosTable.status === "VENDIDA_PROPRIO"
                      ) {
                        r.icone = "Vendida";
                      } else {
                        if (r.CotasUsuariosTable.status === "DISTRATO") {
                          r.icone = "Distrato";
                        } else {
                          if (
                            r.CotasUsuariosTable.status ===
                            "AGUARDANDO_PAGAMENTO"
                          ) {
                            r.icone = "Pendente pagamento";
                          }
                        }
                      }
                    }
                  }
                }

                ArrayNovo.push(r);
              });
            }
            console.log("ArrayNovo", ArrayNovo);
            setVisualizarCotas(ArrayNovo);
            setIsLoading(false);
          } else {
            console.log("Erro ao buscar propriedades do usuário");
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
          }
        }
      }
    };
    fetchToken();
  }, []);

  const info = async () => {
    const URLInfoRepresentante = `${Globais.DOMINIOBACK}/representante/todos/cotausuario/${cotaUsuarioId.current}`;
    const Token = validateToken();

    if (Token) {
      try {
        const responseInfoRepresentante = await axios.get(
          URLInfoRepresentante,
          {
            headers: { Authorization: Token.AuthStr },
          }
        );

        if (responseInfoRepresentante.data.length === 0) {
          warning(
            "Não há representantes. Vamos te levar para a tela de cadastro de representante."
          );
          setTimeout(() => {
            document.location.href = `/cadastroRepresentante/?cotaUsuarioId=${cotaUsuarioId.current}`;
          }, 3000);
        } else {
          let contador = 0;
          let nome;
          let sobrenome;
          let dataAssinatura = "";
          let dataVencimento = "";

          responseInfoRepresentante.data.map((p: any) => {
            if (p.checked === 1) {
              contador = 1;

              nome = p.UsuarioTable.nome;
              sobrenome = p.UsuarioTable.sobrenome;
              dataAssinatura = p.dataAssinatura;
              dataVencimento = p.dataVencimento;
            }
          });
          if (contador > 0) {
            Modal.info({
              title: "Quem está representando?",
              content: (
                <div>
                  <p>Nome: </p>
                  <p>
                    {nome} {sobrenome}
                  </p>
                  <p>Desde: </p>
                  <p>{formatarData(dataAssinatura)}</p>
                  <p>Até: </p>
                  <p>{formatarData(dataVencimento)}</p>
                </div>
              ),
              onOk() {},
            });
          } else {
            warning(
              "Há representantes cadastrados, mas ainda não foram validados. Aguarde que entraremos em contato para prosseguimento."
            );
          }
        }
      } catch (error) {}
    } else {
      document.location.href = "/login";
    }
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const items: MenuProps["items"] = [
    { key: "7", label: "Anúncio de Venda" },
    { key: "1", label: "Detalhes" },
    { key: "2", label: "Ver períodos" },
    { key: "3", label: "Representante" },
    { key: "4", label: "Meus documentos" },
    { key: "5", label: "Informações úteis" },
    { key: "6", label: "Excluir" },
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: "Empreendimento",
      dataIndex: "empreend",
      key: "empreend",
      width: "30%",
      filteredValue: filteredInfo.empreend,
      ...getColumnSearchProps("empreend"),
      sorter: (a, b) => a.empreend.length - b.empreend.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Cidade",
      dataIndex: "nomeCidade",
      key: "nomeCidade",
      width: "20%",
      filteredValue: filteredInfo.nomeCidade,
      ...getColumnSearchProps("nomeCidade"),
    },
    {
      title: "Nº Cota",
      dataIndex: "numeroCota",
      key: "numeroCota",
      width: "5%",
      filteredValue: filteredInfo.numeroCota,
      ...getColumnSearchProps("numeroCota"),
    },
    {
      title: "Bloco / Nº Apto",
      dataIndex: "infoApt",
      key: "infoApt",
      width: "10%",
      align: "center",
    },
    {
      title: "Prioridade",
      dataIndex: "prioridade",
      key: "prioridade",
      width: "10%",
      align: "center",
    },
    {
      title: "Capacidade",
      dataIndex: "capacidade",
      key: "capacidade",
      width: "10%",
      filteredValue: filteredInfo.capacidade,
      ...getColumnSearchProps("capacidade"),
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      width: "20%",
    },
    {
      title: "Status",
      dataIndex: "icone",
      key: "icone",
      width: "5%",
      filters: [
        { text: "Cadastro pendente", value: "Cadastro pendente" },
        { text: "Anúncio pendente pagamento ", value: "Pendente pagamento" },

        { text: "Autenticada", value: "Autenticada" },
        { text: "A Venda", value: "A Venda" },

        { text: "Vendida", value: "Vendida" },
        { text: "Cancelada", value: "Cancelada" },
        { text: "Distrato", value: "Distrato" },
      ],
      filteredValue: filteredInfo.icone,

      onFilter: (value: any, record) => record.icone.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.icone === "Cadastro pendente" ? (
          <Tooltip title='Ainda há pendências no cadastro de sua propriedade. Favor clicar em "Detalhes" para continuar.'>
            <PendingActionsIcon color="primary" />
          </Tooltip>
        ) : row.icone === "Autenticada" ? (
          <Tooltip title="Tudo certo! Propriedade autenticada.">
            <VerifiedIcon color="success" />
          </Tooltip>
        ) : row.icone === "Cancelada" ? (
          <Tooltip title="Propriedade cancelada">
            <CancelIcon color="error" />
          </Tooltip>
        ) : row.icone === "A Venda" ? (
          <Tooltip title="Essa propriedade está sendo anunciada.">
            <SellIcon color="warning" />
          </Tooltip>
        ) : row.icone === "Vendida" ? (
          <Tooltip title="Essa propriedade já foi vendida.">
            <PaidIcon color="success" />
          </Tooltip>
        ) : row.icone === "Distrato" ? (
          <Tooltip title="Distrato">
            <NotInterestedIcon color="error" />
          </Tooltip>
        ) : row.icone === "Pendente pagamento" ? (
          <Tooltip title="Anúncio pendente pagamento">
            <MoneyOffIcon color="error" />
          </Tooltip>
        ) : null,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                empreend.current = row.empreend;
                cotaUsuarioId.current = row.cotaUsuarioId;

                numeroCota.current = row.numeroCota;
                status.current = row.status;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
  const venderPropriedade = () => {
    venderCota(false, 0, cotaUsuarioId.current);
  };

  interface OnClickParams {
    key: string;
    cotaUsuarioId: string; // ou o tipo que for adequado
    numeroCota: string;
    empreend: string;
  }

  const navigate = useNavigate();

  const onClick = async ({
    key,
    cotaUsuarioIdModal,
    numeroCotaModal,
    empreendModal,
    usuarioLogadoIdModal,
  }: any) => {
    const Token = validateToken();
    const perfil = Token?.nda;

    const periodoUsuarioId = periodoUsuario.current;
    if (
      periodoUsuarioId === 0 &&
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "1":
          document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${
            cotaUsuarioId.current || cotaUsuarioIdModal
          }`;

          break;
        case "2":
          localStorage.removeItem("filtrosDispPeriodo");
          localStorage.removeItem("pageDispPeriodo");

          switch (status.current) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
            case "AGUARDANDO_COTA":
            case "AGUARDANDO_DEFINICAO_ANUNCIO":
              error(
                "O cadastro da propriedade está pendente. Favor finalizar!"
              );
              break;
            default:
              document.location.href = `/disponibilizacaoPeriodos/?cotaUsuarioId=${
                cotaUsuarioId.current || cotaUsuarioIdModal
              }&&ncota=${numeroCota.current || numeroCotaModal}&&empreend=${
                empreend.current || empreendModal
              }`;
          }

          break;

        case "3":
          info();
          break;
        case "4":
          //Ver documentos
          document.location.href = `/gerenciarDocumentosProprietarios/?cotaUsuarioId=${
            cotaUsuarioId.current || cotaUsuarioIdModal
          }`;

          break;
        case "5":
          //error("Em desenvolvimento!");
          document.location.href = `/infoEmpreendimento/?empreend=${
            empreend.current || empreendModal
          }`;
          break;
        case "6":
          error(
            "Não é possível excluir essa propriedade. Qualquer dúvida, favor, entrar em contato conosco."
          );

          break;

        case "7":
          const resultPagamento = await verificarPagamentoPorStatus(
            "ATIVA",
            cotaUsuarioId.current || cotaUsuarioIdModal
          );
          if (resultPagamento) {
            warning("Sua propriedade já está sendo anunciada.");
            setTimeout(() => {
              navigate("/gerenciarAnuncioVenda", {
                state: {
                  cotaUsuarioId: cotaUsuarioId.current || cotaUsuarioIdModal,
                  nome: empreend.current || empreendModal,
                  usuarioId: usuarioLogadoId.current || usuarioLogadoIdModal,
                },
              });
            }, 3000);
          } else {
            const resultPagamentoPendente = await verificarPagamentoPorStatus(
              "PENDENTE",
              cotaUsuarioId.current || cotaUsuarioIdModal
            );
            if (resultPagamentoPendente) {
              warning(
                "Existe um pagamento aguardando confirmação. Qualquer dúvida entre em contato conosco."
              );
            } else {
              const formData = {
                usuarioId: usuarioLogadoId.current || usuarioLogadoIdModal,
                cotasUsuariosId: cotaUsuarioId.current || cotaUsuarioIdModal,
                planoAssinatura: "ANUNCIO_PROPRIEDADE",
              };

              const resultadoAssinatura = criarAssinaturaCTU(formData);

              if (await resultadoAssinatura) {
                let formData = {
                  status: "AGUARDANDO_MAISINFO_ANUNCIO",
                };
                const resultadoAtualizarCTU = atualizarCotaUsuarioGlobais(
                  cotaUsuarioId.current || cotaUsuarioIdModal,
                  formData
                );
                if (await resultadoAtualizarCTU) {
                  document.location.href = `${Globais.LINK_PAGAMENTO}`;
                } else {
                  error("Há algo de errado. VCC-003");
                }
              } else {
                error("Há algo de errado. VCC-004");
                return false;
              }
            }
          }
          break;
      }
    }
  };

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    console.log("params", pagination, filters, sorter, extra);
    setFilteredInfo({
      empreend: filters.empreend,
      nomeCidade: filters.nomeCidade,
      numeroCota: filters.numeroCota,
      capacidade: filters.capacidade,
      icone: filters.icone,
    });

    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageCadastroCotas", page);
    }

    localStorage.setItem("filtrosCadastroCotas", JSON.stringify(filters));
    setSemFiltros(false);
  };
  const handleFilter = () => {
    localStorage.removeItem("filtrosCadastroCotas");
    localStorage.removeItem("pageCadastroCotas");
    setSemFiltros(true);
    document.location.reload();
  };

  // const isMobile = useMediaQuery("(max-width: 768px)");
  // const isDesktop = useMediaQuery("(min-width: 769px)");

  const ref = useRef<DropdownRef>(null);
  // State de abertura e fechamento do modal excluir assinatura
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedData, setSelectedData] = useState<any>({
    cotaUsuarioId: null,
    numeroCota: null,
    empreend: null,
    status: null,
  });

  const showModal = (data: any) => {
    setSelectedData(data); // Define os dados da linha selecionada
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal excluir assinatura
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  const handleButtonClick = () => {
    // Simula o clique no menu com uma key específica
    onClick({ key: "1" } as any);
  };

  return (
    <>
      {isLoading && isDesktop ? (
        <Skeleton active />
      ) : isDesktop ? (
        <Container>
          {contextHolder}
          <Row>
            <Col span={3}>
              <Flex align="end" justify="center" style={{ marginTop: 30 }}>
                <a href={`/inicio`}>
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title style={{ marginLeft: 10 }} level={3}>
                  Minhas Propriedades
                </Title>
              </Flex>
            </Col>
            <Col span={3}>
              <Button
                onClick={() =>
                  (document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=0`)
                }
                type="primary"
                style={{ marginTop: 30 }}
              >
                Adicionar
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Flex
                align="start"
                justify="center"
                style={{ width: "100%", overflow: "auto" }}
              >
                <Table
                  columns={columns}
                  dataSource={visualizacaoCotas}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Container>
      ) : isMobile ? (
        <Container>
          <Row>
            {contextHolder}
            <Col span={3}>
              <Flex
                align="end"
                justify="center"
                style={{
                  marginTop: 35,
                }}
              >
                <a href={`/inicio`}>
                  <ArrowBackIcon style={{ color: "#003644" }} />
                </a>
              </Flex>
            </Col>
            <Col span={18}>
              <Flex align="center" justify="center">
                <HomeIcon
                  style={{ color: "#003644", marginTop: 20 }}
                  fontSize="large"
                />
                <Title style={{ marginLeft: 10 }} level={4}>
                  Minhas Propriedades
                </Title>
              </Flex>
            </Col>
          </Row>

          {visualizacaoCotas?.map(
            (row: any, index: number) => (
              console.log("row", row.numeroCota),
              (
                <Row
                  key={`${row.cotaUsuarioId}-${row.numeroCota}-${index}`}
                  style={{
                    width: "100%",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Col span={24}>
                    <DropdownMobile
                      style={{
                        width: "100%",
                        borderBottom: "3px solid #C3CDC7",
                      }}
                    >
                      <DropdownMobile.Item
                        key={row.key}
                        style={{
                          width: "100%",
                          padding: "10px 15px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          textAlign: "left",
                        }}
                        title={
                          <div
                            style={{
                              width: "300px",
                              display: "flex",
                              fontSize: "16px",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                flex: "1",
                                textAlign: "left",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {row.empreend}
                            </span>
                            <span
                              style={{
                                textAlign: "right",
                                marginRight: "40px", // distância entre os dois itens
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                              }}
                            >
                              Nº Cota: {row.numeroCota}
                            </span>
                          </div>
                        }
                      >
                        <ContainerItems>
                          <Items>
                            <strong>Cidade:</strong>{" "}
                            <Icon>{row.nomeCidade}</Icon>
                          </Items>
                          <Items>
                            <strong>Nº Cota:</strong>
                            <Icon>{row.numeroCota}</Icon>
                          </Items>
                          <Items>
                            <strong>Bloco / Nº Apto:</strong>
                            <Icon>{row.infoApt}</Icon>
                          </Items>
                          <Items>
                            <strong>Prioridade:</strong>
                            <Icon>{row.prioridade}</Icon>
                          </Items>
                          <Items>
                            <strong>Capacidade:</strong>
                            <Icon>{row.capacidade}</Icon>
                          </Items>
                          <Items>
                            <strong>Situação:</strong>{" "}
                            <Icon>{row.situacao}</Icon>
                          </Items>
                          <Items>
                            <strong>Status:</strong> <Icon>{row.icone}</Icon>
                          </Items>
                          <Items>
                            <Flex align="center" justify="center">
                              <Button
                                onClick={() =>
                                  showModal({
                                    cotaUsuarioId: row.cotaUsuarioId,
                                    numeroCota: row.numeroCota,
                                    empreend: row.empreend,
                                    status: row.situacao,
                                  })
                                }
                                type="primary"
                                style={{
                                  marginLeft: 80,
                                  marginTop: 30,
                                  backgroundColor: "#003644",
                                  borderColor: "#003644",
                                  color: "white",
                                }}
                              >
                                Ações
                              </Button>
                            </Flex>
                          </Items>
                        </ContainerItems>
                      </DropdownMobile.Item>
                    </DropdownMobile>
                  </Col>
                </Row>
              )
            )
          )}

          <Row
            style={{
              position: "fixed",
              bottom: "4rem", // Distância do rodapé
              right: "3rem", // Distância da borda direita
              zIndex: 1000, // Garante que o botão fique acima de outros elementos
            }}
          >
            <Col span={14}></Col>
            <Col span={10}>
              <Fab
                color="primary"
                aria-label="add"
                onClick={() =>
                  (document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=0`)
                }
              >
                <AddIcon />
              </Fab>
            </Col>
          </Row>

          <ModalAcoes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            onClick={onClick}
            cotaUsuarioId={selectedData.cotaUsuarioId}
            numeroCota={selectedData.numeroCota}
            empreend={selectedData.empreend}
            status={selectedData.status}
            usuarioLogadoId={usuarioLogadoId.current}
            selectedRowKeys={selectedRowKeys} // Substitua com o valor real
            emLote={emLote.current} // Substitua com o valor real
          />
        </Container>
      ) : null}
    </>
  );
}
